<div [class]="footerStyle" id="kt_footer">
	<div [class]="containerClass + ' d-flex flex-column flex-md-row align-items-center justify-content-between'">
		<!-- removed code from here -->
		<div class="nav nav-dark nav nav-dark order-1 order-md-2">
            <a href="javascript:;" target="_blank" class="nav-link pl-0 pr-5">&nbsp;</a>
		</div>
	</div>
</div>
